import React from "react"
import Modal from 'react-bootstrap/Modal'
import { useRoster } from '../StudentsContext';
import { Button, Col, Row } from 'react-bootstrap';
import { ModalType } from "../Import";

interface EnrollmentProps {
    setModalType: (modalType: ModalType) => void
}

export default function EnrollmentForm({ setModalType }: EnrollmentProps) {
    return <>
        <Modal.Body className="g-3">
            <Row>
                <h3>Enrollment Allowed Values</h3>
            </Row>

            <Row>
                <p>Public</p>
                <p>Private</p>
                <p>Cyber</p>
                <p>Homeschooling</p>
                <p>Not Applicable</p>
                <p>Decline to Answer</p>
            </Row>

            <Row>
                <Col>
                    <Button onClick={() => setModalType("default")}>Return to Import</Button>
                </Col>
            </Row>
        </Modal.Body>
    </>
}
